import { faCalculator, faRuler } from '@fortawesome/pro-regular-svg-icons'
import { SectionWrapper } from '@labrav/common'
import { useStyles } from './DimensionDetails.styles'
import { AdditionalUsagePriceView } from '../../../../common/components/AdditionalUsagePriceView/AdditionalUsagePriceView'
import { InstallmentsView } from '../../../../common/components/InstallmentsView/InstallmentsView'
import { StandardCustomDimensions } from '../../../../common/components/StandardCustomDimensions/StandardCustomDimensions'
import type { ViewResellerAuthorizationType } from '../../../../modules/receivedResellerAuthorization/types'
import { ContractDurationType, DiscountType } from '../../../../types/flyout'
import { getPricesArray } from '../../../../modules/resaleAuthorization/action'
import type { PriceTypes } from '../../../../modules/privateOffer/reducer'
import { get } from 'lodash'
import { priceMappingWithAll } from '../../../FreeTrialLabraUI'

export const DimensionDetails = ({
  resellerAuthorization,
  currencySymbol,
}: {
  resellerAuthorization: ViewResellerAuthorizationType
  currencySymbol?: string
}) => {
  const { classes } = useStyles()
  const resaleAuthorizationOriginType = resellerAuthorization?.agreementOrigin
  const isReceivedResellerAuth = resaleAuthorizationOriginType === 'RECEIVED'
  const resaleDimensions = get(
    resellerAuthorization,
    isReceivedResellerAuth ? 'dimensions' : 'products[0].dimensions',
    []
  )
  const multiPriceArray = getPricesArray(resaleDimensions).map(item => ({
    keyName: item as keyof PriceTypes,
    lable: get(priceMappingWithAll, item),
  }))

  const hasAdditionalUsageDimension =
    resaleDimensions?.some(
      dimension =>
        dimension?.isAdditionalUsageAllowed ||
        dimension.type === 'additional_usage'
    ) || false

  const isFlexiblePayment =
    resellerAuthorization?.discountType?.toUpperCase() ===
    DiscountType.FLEXIBLE_PAYMENT_TERMS

  const customContractDuration =
    resellerAuthorization.contractDurationType === ContractDurationType.CUSTOM
  return (
    <>
      <SectionWrapper
        heading="Dimensions details"
        icon={faRuler}
        className={classes.dimensionBox}
        children={
          <div className={classes.dimensionWrapper}>
            <StandardCustomDimensions
              dimensions={resaleDimensions}
              flexiblePaymentTerms={isFlexiblePayment}
              customPriceHeader="Wholesale price"
              customColumns={[{ keyName: 'price', lable: 'Price' }]}
              {...(!isFlexiblePayment && !customContractDuration
                ? { priceArray: multiPriceArray }
                : {})}
              priceColumnName={
                isFlexiblePayment || customContractDuration ? '' : 'prices'
              }
              currencySymbol={currencySymbol}
            />
          </div>
        }
      />

      {isFlexiblePayment && (
        <SectionWrapper
          heading={`Installments (${
            (resellerAuthorization?.installmentInfo || []).length
          })`}
          icon={faRuler}
          children={
            <InstallmentsView
              installments={resellerAuthorization?.installmentInfo?.map(
                item => ({
                  ...item,
                  amount: item?.amount ? Number(item?.amount) : 0,
                })
              )}
              currencySymbol={currencySymbol}
            />
          }
        />
      )}
      {hasAdditionalUsageDimension && (
        <SectionWrapper
          heading="Price for additional usage"
          icon={faCalculator}
          children={
            <AdditionalUsagePriceView
              dimensions={resaleDimensions}
              keyName={'prices.additionalUsagePrice'}
              priceColumnName={'Wholesale price'}
              currencySymbol={currencySymbol}
            />
          }
        />
      )}
    </>
  )
}
